import { NavLink } from "react-router-dom"
import { Map, Route, Calendar, DollarSign, Fuel } from "lucide-react"
import { cn } from "@/lib/utils"

const navItems = [
  { icon: Map, label: "Explore", path: "/" },
  { icon: Route, label: "Shift", path: "/shift" },
  { icon: Calendar, label: "Events", path: "/events" },
  { icon: DollarSign, label: "Earnings", path: "/earnings" },
  { icon: Fuel, label: "Fuel", path: "/fuel" },
]

export function MobileNav() {
  return (
    <nav
      role="navigation"
      aria-label="Main navigation"
      className="fixed bottom-0 left-0 right-0 z-50 border-t bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80 md:hidden safe-area-bottom"
    >
      <div className="flex h-16 items-center justify-around px-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              cn(
                /* Min 44x44 touch target (WCAG 2.5.8) */
                "flex flex-col items-center justify-center gap-0.5 min-w-[44px] min-h-[44px] px-3 py-1.5 rounded-lg",
                "transition-colors duration-150",
                "text-muted-foreground",
                "hover:text-foreground",
                /* Keyboard focus ring */
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-card",
                isActive && "text-foreground bg-muted"
              )
            }
          >
            <item.icon className="h-5 w-5" aria-hidden="true" />
            <span className="text-xs font-medium leading-tight">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
